interface BarCodeSlice {
    barCodeState: string | null;
    handleKeyInput: (key: string) => void;
    resetBarCodeState: () => void;
}

const createBarCodeSlice = (set: any) => {
    let currentBarCode = '';

    return {
        barCodeState: null,
        handleKeyInput: (key: string) => {
            // Guard against undefined or null key
            if (!key || typeof key !== 'string') {
                return;
            }

            if (key === 'Enter') {
                // update state with the barcode
                set(() => ({
                    barCodeState: currentBarCode,
                }));
                currentBarCode = ''; // clear private variable
            } else {
                // create barcode from characters, but only if it's a single character (not Shift, Ctrl, etc.)
                if (key.length === 1) {
                    currentBarCode += key;
                }
            }
        },

        resetBarCodeState: () => {
            currentBarCode = '';
            return set(() => ({
                barCodeState: null,
            }));
        },
    };
};

export { createBarCodeSlice };
export type { BarCodeSlice };
